import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getLatestArticles, categories } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function LatestArticles() {
  const [activeTab, setActiveTab] = useState('all');
  const allArticles = getLatestArticles(12);

  const filteredArticles = activeTab === 'all'
    ? allArticles
    : allArticles.filter((a) => a.categorySlug === activeTab);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            最新文章
          </h2>

          <div className="flex items-center gap-1 bg-background-100 rounded-full p-1 overflow-x-auto max-w-full">
            <button
              onClick={() => setActiveTab('all')}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeTab === 'all'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200'
              }`}
            >
              全部
            </button>
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => setActiveTab(cat.slug)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  activeTab === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        {filteredArticles.length === 0 && (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-background-100 text-foreground-300">
              <i className="ri-article-line text-2xl"></i>
            </div>
            <p className="text-foreground-500">该分类暂无文章</p>
          </div>
        )}

        <div className="text-center mt-8">
          <Link
            to={activeTab === 'all' ? '/category/star-scandal' : `/category/${activeTab}`}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-200 hover:border-primary-300 text-foreground-700 hover:text-primary-600 font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}